import {APIMethod, LocalStorageItem} from '@enums'

import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {QueryClient} from '@tanstack/react-query'

import axiosInstance from './config'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface FetchParams<TBody, TData> {
  method: APIMethod
  url: string
  body?: TBody
  contentType?: string
}

export const fetchData = async <TBody = unknown, TData = unknown>({
  method,
  url,
  body,
  contentType,
}: FetchParams<TBody, TData>): Promise<TData> => {
  const headers = {
    'Content-Type': contentType || 'application/json',
  }

  const response = await axiosInstance({method, url, data: body, headers})
  return response.data
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleAxiosError = (error: any) => ({
  message: error.response?.data?.message ?? error.message,
  name: error.name,
  stack: error.stack,
  cause: error.cause,
})

export function useSafeMutation<TData, TError = unknown, TVariables = void, TContext = unknown>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
) {
  const mutation = useMutation(options)

  return {
    ...mutation,
    mutateAsync: async (variables: TVariables) => {
      try {
        return await mutation.mutateAsync(variables)
      } catch (error) {
        return undefined as TData
      }
    },
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      throwOnError: false,
    },
    mutations: {
      retry: false,
      throwOnError: false,
    },
  },
})
